import { notEmpty } from '@shared/utils/array';
import type {
  FormatDateOptions,
  FormatTimeOptions,
  TimeZone,
} from '@shared/utils/date';
import { formatDateTz, formatTimeTz, userTimeZone } from '@shared/utils/date';
import type { JSX } from 'react';

export interface FormatDateProps {
  date: Date | string | undefined;
  showDate?: boolean;
  showTime?: boolean;
  dateOptions?: FormatDateOptions;
  timeOptions?: FormatTimeOptions;
  timeZone?: TimeZone;
  empty?: JSX.Element | null;
}

const FormatDate = ({
  date,
  showDate = true,
  showTime = true,
  dateOptions,
  timeOptions,
  timeZone,
  empty = null,
}: FormatDateProps) => {
  if (date === undefined) {
    return empty;
  }
  if (!showDate && !showTime) {
    return null;
  }

  const tz = timeZone ?? userTimeZone();
  const formattedDate = showDate ? formatDateTz(date, tz, dateOptions) : null;
  const formattedTime = showTime ? formatTimeTz(date, tz, timeOptions) : null;

  return (
    <>{[formattedDate, formattedTime].filter(notEmpty).join(' ').trim()}</>
  );
};

export default FormatDate;
